<template>
  <div>
    <b-row>
      <b-col>
        <header-view
                class="text-uppercase"
                :title="$t('message.policies.title')"
                :icon="''">
        </header-view>
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col>

        <p>Mit diesen Hinweisen informieren wir Sie über die Verarbeitung Ihrer personenbezogenen Daten durch die
          CodeCamp:N GmbH und die Ihnen nach dem Datenschutzrecht zustehenden Rechte. Verantwortliche Stelle im Sinne
          der Datenschutzgesetze, insbesondere der EU-Datenschutzgrundverordnung (DS-GVO), ist:</p>

        <h5>I. Name und Anschrift des Verantwortlichen</h5>

        <p>Der Verantwortliche im Sinne der Datenschutz-Grundverordnung und anderer nationaler Datenschutzgesetze der
          Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher Bestimmungen ist die:</p>

        <p>
          CodeCamp:N GmbH <br>
          Solgerstr. 18 <br>
          90429 Nürnberg <br>
          Telefon: +49 911 2744 8523 <br>
          E-Mail: info@codecamp-n.com
        </p>

        <br>

        <h5>II. Kontaktdaten des Datenschutzbeauftragten</h5>

        <p>Unseren Datenschutzbeauftragten erreichen Sie unter:</p>

        <p>
          Frau Sabine Sobola <br>
          LiiDU GmbH <br>
          Neupfarrplatz 10 <br>
          93047 Regensburg <br>
          Deutschland <br>
          Telefon: 0941 46392460 <br>
          Mail: info@liidu.de
        </p>

        <br>

        <h5>III. Ihre Betroffenenrechte</h5>

        <p>Sie können unter der oben genannten Adresse Auskunft über die zu Ihrer Person gespeicherten Daten verlangen.
          Darüber hinaus können Sie unter bestimmten Voraussetzungen die Berichtigung oder die Löschung Ihrer Daten
          verlangen. Ihnen kann weiterhin ein Recht auf Einschränkung der Verarbeitung Ihrer Daten sowie ein Recht auf
          Herausgabe der von Ihnen bereitgestellten Daten in einem strukturierten, gängigen und maschinenlesbaren
          Format zustehen.</p>

        <br>

        <h5>IV. Widerspruchsrecht</h5>

        <p>
          Sie haben das Recht, einer Verarbeitung Ihrer personenbezogenen Daten zu Zwecken der Direktwerbung zu
          widersprechen. Verarbeiten wir Ihre Daten zur Wahrung berechtigter Interessen, können Sie dieser Verarbeitung
          widersprechen, wenn sich aus Ihrer besonderen Situation Gründe ergeben, die gegen die Datenverarbeitung
          sprechen.
        </p>

        <br>

        <h5>V. Recht auf Datenübertragbarkeit</h5>

        <p>
          Ihnen steht das Recht zu, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags
          automatisiert verarbeiten, an sich oder an Dritte aushändigen zu lassen. Die Bereitstellung erfolgt in einem
          maschinenlesbaren Format. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen
          verlangen, erfolgt dies nur, soweit es technisch machbar ist.
        </p>

        <br>

        <h5>VI. Recht auf Löschung</h5>

        <p>
          Sie haben das Recht, von dem Verantwortlichen zu verlangen, dass die Sie betreffenden personenbezogenen Daten
          unverzüglich gelöscht werden. Sofern Sie eine endgültige Löschung Ihres angelegten Accounts und somit auch die
          Löschung Ihrer personenbezogenen Daten veranlassen möchten, stehen Ihnen zwei Möglichkeiten zur Verfügung.
          Zum einen können Sie jederzeit eine E-Mail an info@codecamp-n.com schicken und die Löschung Ihrer Daten
          veranlassen. Dabei wird Ihr Account und die damit verbundenen personenbezogenen Daten durch einen
          Administrator gelöscht
        </p>

        <br>

        <h5>VII. Beschwerderecht</h5>

        <p>
          Sie haben die Möglichkeit, sich mit einer Beschwerde an uns oder den oben genannten (o. g.)
          Datenschutzbeauftragten unter den o. g. Kontaktdaten oder an eine Datenschutzaufsichtsbehörde zu wenden.
          Die für uns zuständige Datenschutzaufsichtsbehörde ist:
        </p>

        <p>
          <strong>Aufsichtsbehörde</strong> <br>
          Bayerisches Landesamt für Datenschutzaufsicht <br>
          Promenade 18, 91522 Ansbach <br>
          Postanschrift: Postfach 606, 91511 Ansbach <br>
          Telefon: 0981/180093-0 <br>
          Telefax: 0981/180093-99 <br>
          E-Mail: poststelle@lda.bayern.de <br>
          Homepage: https://www.lda.bayern.de <br>
        </p>

        <br>

        <h5>VIII. Zwecke der Datenverarbeitung durch die verantwortliche Stelle und Dritte</h5>

        <p>

        </p>

        <p>
          Wir verarbeiten Ihre personenbezogenen Daten unter Beachtung der EU-Datenschutz-Grundverordnung (DS-GVO).
        </p>
        <p>
          Meine-vertraege.net ist ein digitaler Vertragsmanager der es Benutzern erlaubt, seine kompletten
          Vertragsverhältnisse zu erfassen und aufzulisten. Der digitale Vertragsmanager wird als
          Assistancedienstleistung der Bestattungsvorsorgeversicherung von der NÜRNBERGER VERSICHERUNG in
          Kooperation mit dem Kuratorium Deutsche Bestattungskultur angeboten.
        </p>
        Sie können sich auf unserer Webseite durch Angaben von Name, Vorname, E-Mail-Adresse, Geburtsdatum,
        Versicherungsnummer und einem Passwort registrieren und einen Account einrichten. Rechtsgrundlage hierfür
        ist der mit Ihnen geschlossene Vertrag nach Art. 6 Abs. 1 S. 1 lit. b) DS-GVO.
        <p>
          Des Weiteren kann der Kontoinhaber Kontaktpersonen bestimmen, welche nach seinem Ableben Einsicht in die ihnen
          zugeordneten Verträge gewährt bekommen. Rechtsgrundlage hierfür ist Ihre Einwilligung nach
          Art. 6 Abs. 1 S. 1 lit. a) DS-GVO.
        </p>
        Um eine Darstellung unserer Webseite zu gewährleisten und unsere Anwendung stetig weiterzuentwickeln,
        verwenden auf unserer Website Cookies. Nähere Informationen zum Einsatz und der Rechtsgrundlage finden
        Sie im Abschnitt „Cookies“.
        <p>
          Des Weiteren kann es sein, dass es uns gesetzlich vorgeschrieben ist, Ihre Daten zu verarbeiten. Diese
          Verarbeitung, ist dann zur Erfüllung einer gesetzlichen Verpflichtung erforderlich (Art. 6 Abs. 1 S. 1 lit. c)
          DS-GVO). Dies ist zum Beispiel in solchen Situationen der Fall, wenn wir durch Gesetz bestimmte
          Aufbewahrungsfristen haben.
        </p>

        <br>

        <h5>IX. Amazon Web Services</h5>

        <p>
          Wir hosten unsere Systeme bei Amazon Web Services, Inc., 410 Terry Avenue North, Seattle WA 98109, USA („AWS“)
          auf der Rechtsgrundlage Vertragserfüllung nach Art. 6 Abs. 1 S.1 lit. b) DS-GVO. Die Systeme werden in der
          EU Region Irland des AWS Netzwerks gehostet. Entsprechend Art. 28 DS-GVO haben wir einen
          Auftragsdatenverarbeitungsvertrag (Data-Processing-Agreement) mit Amazon Web Services abgeschlossen. Dabei
          handelt es sich um einen Vertrag, in dem sich AWS unter anderem dazu verpflichtet, die Daten unserer Nutzer
          zu schützen, entsprechend den festgehaltenen Datenschutzbestimmungen in unserem Auftrag zu verarbeiten und
          insbesondere nicht an Dritte weiterzugeben. Nähere Informationen hierzu finden Sie in der
          <a href="https://aws.amazon.com/de/privacy/?nc1=f_pr">Datenschutzerklärung von AWS</a>.
        </p>

        <br>

        <h5>X. Speicherdauer</h5>

        <p>
          Wir halten uns an die Grundsätze der Datenvermeidung und Datensparsamkeit. Wir speichern Ihre
          personenbezogenen Daten daher nur so lange, wie dies zur Erreichung der hier genannten Zwecke erforderlich ist
          oder wie es die vom Gesetzgeber vorgesehenen vielfältigen Speicherfristen vorsehen. Nach Fortfall des
          jeweiligen Zweckes bzw. Ablauf dieser Fristen werden die entsprechenden Daten routinemäßig und entsprechend
          den gesetzlichen Vorschriften gesperrt oder gelöscht. Ihnen steht es frei, die bei der Registrierung
          angegebenen Daten jederzeit vollständig aus der Datenbank löschen zu lassen. Rechtsgrundlage für die
          Aufbewahrung der Unterlagen für die Dauer der gesetzlichen Aufbewahrungsfristen ist die Erfüllung gesetzlicher
          Vorgaben nach Art. 6 Abs. 1 S. 1 lit. c) DS-GVO.
        </p>

        <br>

        <h5>XI.TLS-Verschlüsselung</h5>

        <p>
          Um die Sicherheit Ihrer Daten bei der Übertragung zu schützen, verwenden wir dem aktuellen Stand der Technik
          entsprechende Verschlüsselungsverfahren (z.B. TLS) über HTTPS.
        </p>

        <br>

        <h5>XII. Kontaktformular</h5>

        <p>
          Treten Sie bzgl. Fragen jeglicher Art per E-Mail mit uns in Kontakt, erteilen Sie uns zum Zwecke der
          Kontaktaufnahme Ihre freiwillige Einwilligung nach Art. 6 Abs. 1 S. 1 lit. a) DS-GVO. Hierfür ist die Angabe
          einer validen E-Mail-Adresse erforderlich. Diese dient der Zuordnung der Anfrage und der anschließenden
          Beantwortung derselben. Die Angabe weiterer Daten ist optional. Die von Ihnen gemachten Angaben werden zum
          Zwecke der Bearbeitung der Anfrage sowie für mögliche Anschlussfragen gespeichert. Nach Erledigung der von
          Ihnen gestellten Anfrage werden personenbezogene Daten automatisch gelöscht.
        </p>

        <br>

        <br>

        <h5>XIII. Verwendung von Google Maps</h5>

        <p>
          Auf unserer Website verwenden wir Google Maps (API) von Google Ireland Limited, Gordon House, 4 Barrow St,
          Dublin, D04 E5W5, Irland (“Google”). Google Maps ist ein Webdienst zur Darstellung von interaktiven
          (Land-)Karten, um geographische Informationen visuell darzustellen. Über die Nutzung dieses Dienstes wird
          Ihnen unser Standort angezeigt und eine etwaige Anfahrt erleichtert.
        </p>

        <p>
          Bereits beim Aufrufen derjenigen Unterseiten, in die die Karte von Google Maps eingebunden ist, werden
          Informationen über Ihre Nutzung unserer Website (wie z.B. Ihre IP-Adresse) an Server von Google übertragen
          und dort gespeichert, hierbei kann es auch zu einer Übermittlung an die Server der Google LLC. in den USA
          kommen. Dies erfolgt unabhängig davon, ob Google ein Nutzerkonto bereitstellt, über das Sie eingeloggt sind
          oder ob ein Nutzerkonto besteht. Wenn Sie bei Google eingeloggt sind, werden Ihre Daten direkt Ihrem Konto
          zugeordnet. Wenn Sie die Zuordnung mit Ihrem Profil bei Google nicht wünschen, müssen Sie sich vor Aktivierung
          des Buttons ausloggen. Google speichert Ihre Daten (selbst für nicht eingeloggte Nutzer) als Nutzungsprofile
          und wertet diese aus. Die Erhebung, Speicherung und die Auswertung erfolgen gemäß Art. 6 Abs. 1 S. 1 lit. a)
          DS-GVO auf Basis ihrer Einwilligung.
        </p>

        <p>
          Wenn Sie mit der künftigen Übermittlung Ihrer Daten an Google im Rahmen der Nutzung von Google Maps nicht
          einverstanden sind, besteht auch die Möglichkeit, den Webdienst von Google Maps vollständig zu deaktivieren,
          indem Sie die Anwendung JavaScript in Ihrem Browser ausschalten. Google Maps und damit auch die Kartenanzeige
          auf dieser Internetseite kann dann nicht genutzt werden.
        </p>

        <p>
          Die Nutzungsbedingungen von Google können Sie unter
          <a href="https://www.google.de/intl/de/policies/terms/regional.html">https://www.google.de/intl/de/policies/terms/regional.html</a>
          einsehen, die zusätzlichen Nutzungsbedingungen für Google Maps finden Sie unter
          <a href="https://www.google.com/intl/de_US/help/terms_maps.html">https://www.google.com/intl/de_US/help/terms_maps.html</a>
        </p>

        <br>

        <h5>XIV. Eingebettete YouTube-Videos</h5>

        <p>
          Auf einigen unserer Webseiten betten wir Youtube-Videos ein. Betreiber der entsprechenden Plugins ist die
          YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066, USA. Wenn Sie eine Seite mit dem YouTube-Plugin besuchen,
          wird eine Verbindung zu Servern von Youtube hergestellt. Dabei wird Youtube mitgeteilt, welche Seiten Sie
          besuchen. Wenn Sie in Ihrem Youtube-Account eingeloggt sind, kann Youtube Ihr Surfverhalten Ihnen persönlich
          zuzuordnen. Dies verhindern Sie, indem Sie sich vorher aus Ihrem Youtube-Account ausloggen.
        </p>

        <p>
          Wird ein Youtube-Video gestartet, setzt der Anbieter Cookies ein, die Hinweise über das Nutzerverhalten sammeln.
        </p>

        <p>
          Wer das Speichern von Cookies für das Google-Ad-Programm deaktiviert hat, wird auch beim Anschauen von
          Youtube-Videos mit keinen solchen Cookies rechnen müssen. Youtube legt aber auch in anderen Cookies
          nicht-personenbezogene Nutzungsinformationen ab. Möchten Sie dies verhindern, so müssen Sie das Speichern
          von Cookies im Browser blockieren.
        </p>

        <p>
          Die Nutzung von YouTube erfolgt auf Grundlage von Art. 6 Abs. 1 S. 1 lit. a) DS-GVO; die Einwilligung ist
          jederzeit widerrufbar.
        </p>

        <p>
          Weitere Informationen zum Datenschutz bei „Youtube" finden Sie in der Datenschutzerklärung des Anbieters unter:
          <a href="https://policies.google.com/privacy?hl=de">https://policies.google.com/privacy?hl=de</a>
        </p>

        <br>

        <h5>XV. Änderung unserer Datenschutzbestimmungen</h5>

        <p>
          Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen
          Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen, z.B.
          bei der Einführung neuer Services. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung. Die
          aktuelle Datenschutzerklärung ist auf dem Stand des 14.07.2021.
        </p>

        <br>

        <h5>XVI. Fragen zum Datenschutz</h5>

        <p>
          Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine E-Mail an info@codecamp-n.com oder wenden
          Sie sich direkt an den von uns bestellten Datenschutzbeauftragten unter den oben genannten Kontaktdaten.
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import HeaderView from '@/components/common/HeaderView'

  export default {
    name: 'Policies',
    components: {
      HeaderView
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/info/Policies.vue